module.exports = __webpack_public_path__ + "static/media/10-Clubs.d5fe2680.svg";